import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {
  ListRenderItemInfo,
  View,
  Image,
  Text,
  Platform,
  ImageStyle,
  ViewStyle,
} from 'react-native';
import styleSheet, {backgroundColor} from './styles';
import {observer} from 'mobx-react';
import {TranscriptionChatData} from 'services/API/ClassApi/ClassApiModels';

export interface TranscriptionsChatListCell {
  itemProps: ListRenderItemInfo<TranscriptionChatData>;
}

const TranscriptionsChatListCell = observer(
  (props: TranscriptionsChatListCell) => {
    const theme = useTheme();
    const styles = styleSheet(theme);
    const isMobile = Platform.OS != 'web';
    const startTimeText = isMobile
      ? props.itemProps.item.startOffset + ' - '
      : props.itemProps.item.startOffset;
    const speaker = isMobile
      ? `${props.itemProps.item.firstName} ${props.itemProps.item.lastName}:`
      : `${props.itemProps.item.firstName} ${props.itemProps.item.lastName}`;

    const LeftPart = (
      <View style={styles.leftContainer}>
        <Image
          source={theme.images.dots}
          style={styles.dotsStyle as ImageStyle}
        />
        <View style={styles.timeStyle}>
          <Text style={styles.timeTextStyle}>{startTimeText}</Text>
          <Text style={styles.timeTextStyle}>
            {props.itemProps.item.endOffset}
          </Text>
        </View>

        <Text style={styles.userNameTextStyle}>{speaker}</Text>
      </View>
    );

    const RightPart = (
      <View style={styles.rightContainer}>
        <Text style={styles.transcriptionTextStyle}>
          {props.itemProps.item.transcription}
        </Text>
      </View>
    );

    return (
      <View
        style={[
          styles.container,
          Platform.OS === 'web'
            ? backgroundColor(props.itemProps.index, theme)
            : {},
        ]}>
        {LeftPart}
        {RightPart}
      </View>
    );
  },
);

export default TranscriptionsChatListCell;
